import styled from "styled-components";
import { ctaGradient, modalOverlay } from "../sharedModalStyles";

export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  ${modalOverlay}
`;

export const Dialog = styled.div`
  width: min(380px, calc(100vw - 32px));
  min-height: 203.875px;
  padding: 29px 25px 25px;
  color: #ffffff;
  border: 2px solid transparent;
  border-radius: 22px;
  background:
    linear-gradient(#0b0b0b, #0b0b0b) padding-box,
    ${ctaGradient} border-box;
  box-shadow:
    0 20px 40px rgba(0, 0, 0, 0.5),
    0 0 0 0.5px rgba(255, 255, 255, 0.04);
`;

export const Title = styled.h2`
  margin: 0;
  color: #ffffff;
  font-size: 19px;
  font-weight: 600;
  line-height: 28.5px;
  letter-spacing: -0.025em;
`;

export const Body = styled.p`
  margin: 0;
  color: rgba(255, 255, 255, 0.55);
  font-size: 15px;
  line-height: 24px;
  letter-spacing: 0;
`;

export const Actions = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-top: 24px;
`;

const PromptButton = styled.button`
  min-width: 0;
  height: 41px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  cursor: pointer;
  transition:
    transform 140ms ease,
    opacity 140ms ease,
    background 140ms ease;

  &:hover {
    transform: translateY(-1px);
  }

  &:focus-visible {
    outline: 2px solid rgba(255, 255, 255, 0.92);
    outline-offset: 2px;
  }
`;

export const SecondaryButton = styled(PromptButton)`
  color: rgba(255, 255, 255, 0.7);
  border: 1px solid transparent;
  background:
    linear-gradient(#0b0b0b, #0b0b0b) padding-box,
    ${ctaGradient} border-box;

  &:hover {
    background:
      linear-gradient(rgba(13, 106, 195, 0.12), rgba(13, 106, 195, 0.12)) padding-box,
      ${ctaGradient} border-box;
  }
`;

export const PrimaryButton = styled(PromptButton)`
  color: #ffffff;
  border: 0;
  background: ${ctaGradient};

  &:hover {
    opacity: 0.94;
  }
`;
